/**
 * Calculates percentage change by comparing the latest value with the average of all values in the period.
 *
 * @param data Array of data points with score values
 * @returns Percentage change rounded to nearest integer
 */
const calculateAveragePercentageChange = (data: Array<{ score: number | null }>): number => {
  const nonNullResults = data.filter(item => item.score !== null && item.score !== undefined);

  if (nonNullResults.length === 0) {
    return 0;
  }

  const lastNonNullScore = [...nonNullResults].reverse()[0]?.score;
  const currentValue = lastNonNullScore ?? 0;

  const avgFromPeriod = nonNullResults.reduce((acc, item) => acc + (item.score || 0), 0) / nonNullResults.length;

  if (avgFromPeriod === 0) {
    return 0;
  }

  const diff = ((currentValue - avgFromPeriod) / avgFromPeriod) * 100;

  return Math.round(diff);
};

export default calculateAveragePercentageChange;
